import { useEffect } from 'react'

export default function SEO({
  title,
  description,
  canonical,
  ogImage,
  ogType = 'website',
}) {
  useEffect(() => {
    // 1. Opdater document title
    if (title) {
      document.title = title
    }

    // 2. Sikr sprog på html-tag
    if (document.documentElement) {
      document.documentElement.lang = 'da'
    }

    // Hjælpefunktion til at sætte eller oprette meta-tag
    const setMeta = (attr, key, content) => {
      if (!content) return
      let el = document.head.querySelector(`meta[${attr}="${key}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, key)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    // Hjælpefunktion til link tags (fx canonical)
    const setLink = (rel, href) => {
      if (!href) return
      let el = document.head.querySelector(`link[rel="${rel}"]`)
      if (!el) {
        el = document.createElement('link')
        el.setAttribute('rel', rel)
        document.head.appendChild(el)
      }
      el.setAttribute('href', href)
    }

    // 3. Opdater meta tags
    if (description) {
      setMeta('name', 'description', description)
      setMeta('property', 'og:description', description)
      setMeta('name', 'twitter:description', description)
    }

    if (title) {
      setMeta('property', 'og:title', title)
      setMeta('name', 'twitter:title', title)
    }

    setMeta('property', 'og:type', ogType)
    setMeta('name', 'twitter:card', 'summary_large_image')

    const currentUrl = canonical || (typeof window !== 'undefined' ? window.location.href : '')
    if (currentUrl) {
      setMeta('property', 'og:url', currentUrl)
      setLink('canonical', currentUrl)
    }

    if (ogImage) {
      setMeta('property', 'og:image', ogImage)
      setMeta('name', 'twitter:image', ogImage)
    }
  }, [title, description, canonical, ogImage, ogType])

  return null
}
